import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectConfiguration } from './ducks/we-spin-selectors';
import { Clip } from './types/Clip';

interface WeSpinClipMediaProps {
	clip: Clip;
}

type Media = {
	type: 'clip' | 'video' | 'unknown';
	id: string;
};

type VideoConfig = {
	weSpinClipSlugRegexes: string;
	weSpinClipEmbedUrl: string;
	weSpinVideoEmbedUrl: string;
};
const WeSpinClipMedia: React.FC<WeSpinClipMediaProps> = ({ clip }) => {
	const { weSpinClipSlugRegexes, weSpinClipEmbedUrl, weSpinVideoEmbedUrl } = useSelector(
		selectConfiguration
	) as VideoConfig;

	const media: Media = useMemo(() => {
		if (!weSpinClipSlugRegexes) {
			return {
				type: 'unknown',
				id: clip?.url || ''
			};
		}

		const regexes = weSpinClipSlugRegexes.split(',');
		// eslint-disable-next-line no-restricted-syntax
		for (const regex of regexes) {
			const match = clip?.url.match(regex);
			if (match && match.groups) {
				if (match.groups.slug) {
					return { type: 'clip', id: match.groups.slug };
				}
				if (match.groups.videoID) {
					return { type: 'video', id: match.groups.videoID };
				}
			}
		}

		return {
			type: 'unknown',
			id: clip?.url
		};
	}, [clip, weSpinClipSlugRegexes]);

	const iframeUrl = useMemo(() => {
		switch (media.type) {
			case 'clip':
				return !weSpinClipEmbedUrl
					? media.id
					: weSpinClipEmbedUrl.replace('{slug}', media.id).replace('{parent}', window.location.hostname);
			case 'video':
				return !weSpinVideoEmbedUrl
					? media.id
					: weSpinVideoEmbedUrl.replace('{videoID}', media.id).replace('{parent}', window.location.hostname);
			default:
				break;
		}

		return media.id;
	}, [weSpinClipEmbedUrl, weSpinVideoEmbedUrl, media]);

	return (
		<div
			role="presentation"
			className="item__image large-item-img-wrapper u-relative u-b-radius-top u-cursor-hand gamecard-tags"
		>
			{iframeUrl && (
				<iframe style={{ width: '100%', height: '100%' }} title={`clip-iframe-${clip?.id}`} src={iframeUrl} />
			)}
		</div>
	);
};

export default WeSpinClipMedia;
